import './LegalPages.css';

export default function DocsPage() {
  return (
    <div className="legal-page docs-page">
      <div className="legal-container">
        <a href="/" className="legal-back">← Back to Home</a>
        
        <h1>Documentation</h1>
        <p className="legal-subtitle">Everything you need to get started with Nexus AI Recommendations</p>

        <section className="docs-section">
          <h2>🚀 Getting Started</h2>
          
          <div className="docs-card">
            <h3>Installation</h3>
            <ol>
              <li>Click "Install App" on our homepage and enter your Shopify store domain</li>
              <li>Authorize the app in your Shopify admin</li>
              <li>The app will automatically sync your product catalog</li>
              <li>Configure your widget settings and you're ready to go!</li>
            </ol>
          </div>

          <div className="docs-card">
            <h3>Adding the Widget to Your Theme</h3>
            <p>Our widget integrates automatically using Shopify's App Blocks:</p>
            <ol>
              <li>Go to your Shopify Admin → Online Store → Themes</li>
              <li>Click "Customize" on your active theme</li>
              <li>Navigate to your Product page template</li>
              <li>Click "Add block" and select "Nexus AI Recommendations"</li>
              <li>Position the block where you want recommendations to appear</li>
              <li>Save your changes</li>
            </ol>
          </div>
        </section>

        <section className="docs-section">
          <h2>⚙️ Configuration</h2>
          
          <div className="docs-card">
            <h3>Widget Settings</h3>
            <p>Customize your widget appearance:</p>
            <ul>
              <li><strong>Title:</strong> The heading displayed above recommendations</li>
              <li><strong>Products to Show:</strong> Number of products displayed (2-8)</li>
              <li><strong>Layout:</strong> Grid or carousel display</li>
              <li><strong>Colors:</strong> Match your brand colors</li>
              <li><strong>Font:</strong> Use your theme font or a custom one</li>
            </ul>
          </div>

          <div className="docs-card">
            <h3>Recommendation Types</h3>
            <p>Choose from multiple recommendation algorithms:</p>
            <ul>
              <li><strong>Similar Products:</strong> Products viewed by customers who viewed this item</li>
              <li><strong>Frequently Bought Together:</strong> Products commonly purchased together</li>
              <li><strong>Trending Now:</strong> Popular products based on recent activity</li>
              <li><strong>Personalized:</strong> Tailored suggestions based on browsing history</li>
              <li><strong>Recently Viewed:</strong> Products the customer has viewed</li>
              <li><strong>New Arrivals:</strong> Your latest products</li>
            </ul>
          </div>
        </section>

        <section className="docs-section">
          <h2>📊 Analytics</h2>
          
          <div className="docs-card">
            <h3>Understanding Your Dashboard</h3>
            <p>Track the performance of your recommendations:</p>
            <ul>
              <li><strong>Impressions:</strong> How many times the widget was shown</li>
              <li><strong>Clicks:</strong> Number of product clicks from recommendations</li>
              <li><strong>Click Rate:</strong> Percentage of impressions that resulted in clicks</li>
              <li><strong>Conversions:</strong> Sales attributed to recommendation clicks</li>
              <li><strong>Revenue:</strong> Total revenue from recommendation-driven sales</li>
              <li><strong>ROI:</strong> Return on investment from your subscription</li>
            </ul>
          </div>
        </section>

        <section className="docs-section">
          <h2>🔧 Troubleshooting</h2>
          
          <div className="docs-card">
            <h3>Common Issues</h3>
            
            <h4>Widget not appearing</h4>
            <ul>
              <li>Ensure the app block is added to your theme</li>
              <li>Check that the widget is enabled in app settings</li>
              <li>Verify your product catalog has synced successfully</li>
            </ul>

            <h4>No recommendations showing</h4>
            <ul>
              <li>New stores need time to collect behavior data</li>
              <li>Ensure you have more than 10 products in your catalog</li>
              <li>Check that products aren't excluded by filters</li>
            </ul>

            <h4>Widget loading slowly</h4>
            <ul>
              <li>Our widget is optimized for speed; slow loading usually indicates network issues</li>
              <li>Try clearing your browser cache</li>
              <li>Contact support if the issue persists</li>
            </ul>
          </div>
        </section>

        <section className="docs-section">
          <h2>📧 Need Help?</h2>
          <div className="docs-card">
            <p>
              Can't find what you're looking for? Our support team is here to help!
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:support@shopicraft-solutions.com">support@shopicraft-solutions.com</a>
            </p>
            <p>
              We typically respond within 24 hours on business days.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
